import { Action } from "common/types";

import { actionTypes } from "./actions";

export type ModuleState = {
  attempting: string | null | undefined;
};

export const initialiseState = (): ModuleState => ({
  attempting: null
});

export default function reducer(
  state: ModuleState,
  action: Action<string | null | undefined>
): ModuleState {
  switch (action.type) {
    case actionTypes.setAttemptingWord: {
      return { ...state, attempting: action.payload };
    }

    default: {
      throw new Error(
        `Image label module-state reducer, action type ${action.type} not recognised`
      );
    }
  }
}
